import { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Auth, Hub } from "aws-amplify";
import { HttpMainApi } from "../../interface/main-api";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
 
import { userState } from "../../interface/MainInterface";
 
import Toast from "../../utils/Toast";
import { Typography } from "@mui/material";
 
import { appConfig } from "../../config/Config";
import { AES, enc } from "crypto-js";
// 환경 확인
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
 
const contentPath = isLocalhost ? "개발서버 로그인" : "로그인";
 
interface propsType {
  userState: userState;
}
 
const unAuthAPI = new HttpUnAuthApi();

const SsoLogin = (props: propsType) => {
  // url 가져오기
  const stateInfo: URLSearchParams = new URLSearchParams(window.location.search);
 
  function decodeJwtPayload(idToken: string) {
    const base64Url = idToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }
 
  useEffect(() => {
    if (isLocalhost) console.log("로컬환경입니다");
    console.log("여기가 redirect 되는곳임.");
    // 통합인증 서버에서 인사이트랩스를 클릭하면 여기로 redirect - 테스트사이트에서 바로 code와 state 보내줄거.
    // code, state를 수신 - 없으면 리턴
    // 세션의 저장된 state와 수신한 state 비교하여 위변조 여부 확인 - CSRF 방지용?
    // 람다 호출
    //  naon 인증 서버에서 위변조 여부 확인
    //  code를 사용해 통합인증서버에 토큰요청
    //  id_token을 디코딩하여 사용자 정보 추출
    //  ddb조회해서 문제없는지확인 등록 인원인지 확인.
    // 코그니토 로그인.
    // procSesson();
    const ssoLogin = async () => {
      console.log("ssoLogin 시작");

      const iamBase = isLocalhost ? "https://deviamhart.ehyundai.com/iam" : "https://iamhart.ehyundai.com/iam";
      // const iamBase = "http://10.100.166.147:443/iam";
      // const iamBase = "http://10.100.166.147:80/iam";
 
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code") || "";
      const state = urlParams.get("state");
      // const redirectUri = window.location.origin + window.location.pathname;
      const redirectUri = "https://aitb.ai-lewis.com/ssologin";
      console.log("redirectUri : ", redirectUri);
 
      // 1. 최초 진입이면 IAM 로그인 페이지로로 리다이렉트
      if (!code) {
        console.log("[SSO] 최초 진입");
        const encodedRedirect = encodeURIComponent(redirectUri);
        console.log("[SSO] redirect주소 : ", encodedRedirect);
 
        const randomValue = () => {
          const bytes = crypto.getRandomValues(new Uint8Array(32));
          return btoa(String.fromCharCode(...Array.from(bytes))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        };
        const state = randomValue();
        const nonce = randomValue();
        const verifier = randomValue();
        const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
        const challenge = btoa(String.fromCharCode(...Array.from(new Uint8Array(digest))))
          .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        sessionStorage.setItem("oidc_state", state);
        sessionStorage.setItem("oidc_nonce", nonce);
        sessionStorage.setItem("oidc_verifier", verifier);
 
        const module = urlParams.get("module");
        const menu = urlParams.get("menu");
 
        const loginUrl = new URL(`${iamBase}/oauth2/authorize`);
        loginUrl.searchParams.set("client_id", isLocalhost ? process.env.REACT_APP_DEV_CLIENT_ID! : process.env.REACT_APP_PROD_CLIENT_ID!);
        loginUrl.searchParams.set("redirect_uri", redirectUri);
        loginUrl.searchParams.set("scope", "openid");
        loginUrl.searchParams.set("response_type", "code");
        loginUrl.searchParams.set("state", state);
        loginUrl.searchParams.set("nonce", nonce);
        loginUrl.searchParams.set("code_challenge", challenge);
        loginUrl.searchParams.set("code_challenge_method", "S256");
        if (module) loginUrl.searchParams.set("module", module);
        if (menu) loginUrl.searchParams.set("menu", menu);
 
 
        // 리다이렉트 호출 - 임시 주석 - 외부에서는 당연히안되니까
        if (!isLocalhost) {
          console.log("리다이렉트");
          window.location.href = loginUrl.toString();
          return;
        }
      }
 
      // 2. state 위변조 확인
      if (!isLocalhost || code) {
        console.log("[SSO] state 위변조 확인");
        const storedState = sessionStorage.getItem("oidc_state");
        if (!state || !storedState || state !== storedState) {
          alert("CSRF 검증 실패");
          return;
        }
        sessionStorage.removeItem("oidc_state");
      }

      if (code) {
        const callbackUrl = new URL(window.location.href);
        callbackUrl.searchParams.delete("code");
        callbackUrl.searchParams.delete("state");
        window.history.replaceState(window.history.state, "", callbackUrl.toString());
      }
 
      if (isLocalhost) {
        alert("로컬 SSO는 별도의 테스트 환경 설정이 필요합니다.");
        return;
      }
      const nonce = sessionStorage.getItem("oidc_nonce");
      const verifier = sessionStorage.getItem("oidc_verifier");
      sessionStorage.removeItem("oidc_nonce");
      sessionStorage.removeItem("oidc_verifier");
      if (!code || !nonce || !verifier) {
        alert("SSO 인증 요청 정보가 없습니다.");
        return;
      }

      try {
        const baseUrl = process.env.REACT_APP_UNAUTH_API_URL;
        if (!baseUrl) throw new Error("SSO endpoint is not configured");
        const tokenRes = await fetch(`${baseUrl.replace(/\/+$/, "")}/sso-exchange`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, nonce, code_verifier: verifier }),
        });
        const tokenJson = await tokenRes.json();
        if (!tokenRes.ok || tokenJson.code !== "200" || typeof tokenJson.data?.id_token !== "string") {
          throw new Error("SSO token exchange failed");
        }
        const claim = decodeJwtPayload(tokenJson.data.id_token);
        if (typeof claim.emp_no !== "string" || !claim.emp_no) throw new Error("Invalid SSO subject");
        await check_user(claim.emp_no);
      } catch (e) {
        console.error("[SSO] 토큰 요청 실패");
        alert("로그인 중 오류 발생");
      }
    };
    ssoLogin();
  }, []);
 
  const check_user = async (key_id: string) => {
    console.log("check_user");
    // 코그니토 가입자만 사용해서.
    const param: any = {
      command: "get_hart_user_info",
      user_id: key_id,
    };
    const res = await unAuthAPI.post(param);
    if ("" + res.code == "200") {
      fnUserCount(key_id);
      procSession(res.response.user_info);
    } else {
      console.log("사용자 확인 실패");
    }
  };
 
  const fnUserCount = async (userId: string) => {
    const param: any = {
      command: "update_user_count",
      user_id: userId,
    };
  
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
    }    
  };
  
  const procSession = (sessionData: any) => {
    const sessionObj: any = {
      id: sessionData.sk,
      isAdmin: sessionData.is_admin,
      isSuperAdmin: sessionData.is_super_admin,
      name: sessionData.name,
      userInfo1: sessionData.user_info1,
      userInfo2: sessionData.user_info2,
      userInfo3: sessionData.user_info3,
      userInfo4: sessionData.user_info4,
      expire: Date.now() + 1000 * 60 * 60 * 24, // 24시간
    };
    console.log("session 저장");
    const objString = JSON.stringify(sessionObj);
    const encObjString = AES.encrypt(objString, appConfig.seed).toString();
    window.localStorage.setItem(appConfig.sessionName, encObjString);

    window.location.href = "/";
  }
 
  return (
    <div className="wrapper hart-login">
      <div className="hart-login-box">
        {/* <h2>
          <img src="/images/bi-new.png" />
        </h2> */}
        <p>AITB </p>
        <div className="form-wrap"> H-art를 통해서 접속해주시기 바랍니다.</div>
        <div className="hart-footer">
          <p className="copyright">© Hyundai. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};
 
export default SsoLogin;
